import { Component, Inject } from '@angular/core'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { NGXLogger } from 'ngx-logger'
import { SharedService } from '../../../../services/shared.service'
import { VehicleDocumentsService } from '../../../../services/vehicle-documents.service'
import { GalleryService } from '../../../../services/gallery.service'
import { type VehicleDTOExtended } from '../../../../services/vehicles.service'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
interface DialogData {
  document
  vehicle?: VehicleDTOExtended
}

@Component({
  selector: 'customer-portal-app-revolution-vehicle-document-delete-confirmation-popup',
  standalone: true,
  templateUrl: './vehicle-document-delete-confirmation-popup.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule
  ]
})
export class RevolutionVehicleDocumentDeleteConfirmationPopupComponent {
  disabled = false
  constructor (
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly vehicleDocumentsService: VehicleDocumentsService,
    private readonly dialogRef: MatDialogRef<RevolutionVehicleDocumentDeleteConfirmationPopupComponent>,
    private readonly dialog: MatDialog,
    private readonly logger: NGXLogger,
    private readonly sharedService: SharedService,
    private readonly galleryService: GalleryService
  ) {}

  onDeleteConfirmationSubmit (): void {
    // prevent delete if its profile picture
    if (this.data.document.profilePicture === true) {
      this.sharedService.openConfirmationPopup(
        'shared.error',
        'customerPortal.customer-portal.vehicle-profile-picture.cannot-delete'
      )
      this.dialogRef.close()
      return
    }

    this.disabled = true
    this.vehicleDocumentsService
      .deleteVehicleDocument(this.data.document.id.toString())
      .subscribe(
        picture => {
          this.dialogRef.close(true)
          this.disabled = false
          this.sharedService.openConfirmationPopup(
            'shared.successful',
            'customerPortal.customer-portal.vehicle.documents-menu.delete-success'
          )
        },
        error => {
          this.logger.log(error)
          this.disabled = false
          this.sharedService.openConfirmationPopup(
            'shared.successful',
            'shared.general-error-message'
          )
        }
      )
  }
}
